import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "User Data", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "ID", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Name", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Act as", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Since you're an administrator, you have global access to all pages. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" In order to test different display options, you can act as any other user types. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Select how you'd like to impersonate yourself:", -1)
const _hoisted_7 = { class: "p-field-radiobutton" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "none" }, "None", -1)
const _hoisted_9 = { class: "p-field-radiobutton" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "brand" }, "Brand", -1)
const _hoisted_11 = { class: "p-field-radiobutton" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "creator" }, "Creator", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_app_list_page = _resolveComponent("app-list-page")!

  return (_openBlock(), _createBlock(_component_app_list_page, {
    title: "Admin",
    showSearch: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createElementVNode("p", null, [
          _hoisted_2,
          _createTextVNode(": " + _toDisplayString(_ctx.user.id), 1)
        ]),
        _createElementVNode("p", null, [
          _hoisted_3,
          _createTextVNode(": " + _toDisplayString(_ctx.user.name), 1)
        ]),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("p", null, [
          _createTextVNode("Currently you act as: "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.user.type), 1)
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_RadioButton, {
            id: "none",
            name: "none",
            value: "",
            modelValue: _ctx.actAs,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.actAs) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_RadioButton, {
            id: "brand",
            name: "brand",
            value: _ctx.UserType.BrandOwner,
            modelValue: _ctx.actAs,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.actAs) = $event))
          }, null, 8, ["value", "modelValue"]),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_RadioButton, {
            id: "creator",
            name: "creator",
            value: _ctx.UserType.Creator,
            modelValue: _ctx.actAs,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.actAs) = $event))
          }, null, 8, ["value", "modelValue"]),
          _hoisted_12
        ]),
        _createVNode(_component_Button, {
          label: "Save",
          icon: "pi pi-save",
          onClick: _ctx.saveActAs
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}